import './plugins/axios'
import { createApp } from 'vue'
import "./assets/css/main.scss"
import "./assets/css/black.theme.scss"
import "./assets/css/white.theme.scss"
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import { createPinia } from 'pinia'
import VueGtag from 'vue-gtag-next';

createApp(App)
  .use(router)
  .use(store)
    .use(i18n)
    .use(createPinia())
    .use(VueGtag, {
        property: {
            id: 'G-7G3QQGST63'
        }
    }, router)
  .use(vuetify)
  .mount('#app')
